export default __webpack_public_path__ + "static/media/Gold.23d50c0a.png";